








































import { Component, Prop, Vue } from 'vue-property-decorator';
import { CourseItem } from '@/resource/course-item/course-item.model';
import VuePdfApp from 'vue-pdf-app';
import VueYouTubeEmbed from 'vue-youtube-embed';
import MainButton from '@/main-components/common/MainButton.vue';
Vue.use(VueYouTubeEmbed);

@Component({
  components: { VuePdfApp, MainButton },
})
export default class CourseContent extends Vue {
  @Prop({ required: true })
  courseItems: CourseItem[];

  @Prop({ required: true })
  isPremiumStatus: boolean;

  @Prop({ required: true })
  isPurchased: boolean;

  isPdfRendered = false;
  heightPapers = 10;
  pdfConfig = {
    toolbar: {},
  };

  get updatedCourseItems() {
    if (!this.isPremiumStatus || !this.isPurchased) {
      const updatedCourseItems = this.courseItems.slice(0, 2);
      return updatedCourseItems;
    } else {
      return this.courseItems;
    }
  }

  redirect(collectionUuid: string) {
    this.$router.push(`/collections/${collectionUuid}/start`);
  }

  pagesRendered() {
    this.isPdfRendered = true;
    this.updatePdfHeight();
    window.addEventListener('resize', this.updatePdfHeight);
  }

  updatePdfHeight() {
    const pages = document.getElementsByClassName('page') || [];
    const currentHeight = pages && pages[0] && pages[0].scrollHeight;

    this.heightPapers = currentHeight * pages.length;
  }

  beforeDestroy() {
    window.removeEventListener('resize', this.updatePdfHeight);
  }

  playingVideoEvent(videoId: string) {
    this.$sendMpEvent({
      event: this.$mp_value.CoursePlayVideo,
      properties: {
        videoId: videoId,
      },
    });
  }
}
